import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@workspace/ng-config';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { SessionStorageKey } from '../models/storage.enum';

export const ImpersonationInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (typeof window === 'undefined') {
    return next(req);
  }
  const cookieService = inject(CookieService);

  if (req.url.includes(`${environment.auth.keycloak.host}/realms/`)) {
    return next(req);
  }
  const targetUserId = cookieService.get(SessionStorageKey.IMPERSONATE_USER_ID);

  if (targetUserId) {
    const cloned = req.clone({
      headers: req.headers.set('X-Impersonate-User', targetUserId),
    });
    return next(cloned);
  }
  return next(req);
};
